var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-box image-box-filter shadow-b"},[_c('m-img',{staticClass:"img-cov",attrs:{"src":_vm.image,"alt":"Unsplashed Random"}}),_c('div',{staticClass:"centered"},[_vm._t("p-1")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }